<app-header-container>
  <div class="d-flex flex-column gap-2 gap-xl-4" [style.background-color]="'#fff'" *ngIf="!isLoading; else loading">
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" />
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center gap-2">
        <div class="header-text">{{ headerTitle }}</div>
        <app-status-pill *ngIf="statusPill" [statusPill]="statusPill" />
        <ng-content select="[headerTitleSuffix]"></ng-content>
      </div>
      <ng-content></ng-content>
    </div>
  </div>
  <div *ngIf="tabs.length > 0" class="header-row tab-bar">
    <app-tab-bar [tabs]="tabs" (selectedTab)="selectedTab.emit($event)" />
  </div>
</app-header-container>

<ng-template #loading>
  <div class="d-flex flex-column gap-3">
    <lib-loading-shimmer [height]="'1rem'" />
    <lib-loading-shimmer [height]="'2rem'" />
  </div>
</ng-template>
